export const SET_CALENDAR_FILTER_LOADING = 'SET_CALENDAR_FILTER_LOADING'

export function setFiltersLoading (isLoading) {
  return {
    type: SET_CALENDAR_FILTER_LOADING,
    payload: {
      isLoading,
    },
  }
}

export const SET_CALENDAR_IS_LOADING = 'SET_CALENDAR_IS_LOADING'

export function setCalendarIsLoading (year, month) {
  return {
    type: SET_CALENDAR_IS_LOADING,
    payload: {
      year,
      month,
    }
  }
}

export const SET_CALENDAR_FILTER = 'SET_CALENDAR_FILTER'

export function setCalendarFiltersForLocation (locationId) {
  return {
    type: SET_CALENDAR_FILTER,
    payload: {
      locationId,
      ...(!locationId && { serviceIds: null, areaId: null })
    },
  }
}

export function setCalendarFiltersForArea (areaId) {
  return {
    type: SET_CALENDAR_FILTER,
    payload: {
      areaId,
    },
  }
}

export function setCalendarFiltersForTechnician (technicianId) {
  return {
    type: SET_CALENDAR_FILTER,
    payload: {
      technicianId,
    },
  }
}

export function setCalendarFiltersForService (serviceIds) {
  return {
    type: SET_CALENDAR_FILTER,
    payload: {
      serviceIds,
    },
  }
}

export function setCalendarFilterDate (date) {
  return {
    type: SET_CALENDAR_FILTER,
    payload: {
      date,
    },
  }
}

export function setCurrentView (currentView) {
  return {
    type: SET_CALENDAR_FILTER,
    payload: {
      currentView,
    },
  }
}




// WEBPACK FOOTER //
// ./src/actions/calendar-filters.js